import {
  archIcon,
  arcIcon,
  bridgeIcon,
  bulgeIcon,
  coneIcon,
  downwardIcon,
  normalIcon,
  perspectiveIcon,
  pinchIcon,
  pointedIcon,
  upwardIcon,
  valleyIcon
} from '~/constants/InlineSvgs';

export const OUTLINE = {
  None: 0,
  'Very Thin': 1,
  Thin: 1.6,
  Medium: 2.56,
  Thick: 4.1,
  'Very Thick': 6.55
};

export const NORMAL_EFFECT = 'normal';

export const EFFECTS = [
  {
    name: NORMAL_EFFECT,
    type: NORMAL_EFFECT,
    values: ['0'],
    defaultValue: '0',
    icon: normalIcon
  },
  {
    name: 'curve',
    type: 'arc',
    values: [
      '0.5',
      '1.0',
      '2.0',
      '4.0',
      '8.0',
      '32.0',
      '-32.0',
      '-8.0',
      '-4.0',
      '-2.0',
      '-1.0',
      '-0.5'
    ],
    defaultValue: '2.0',
    icon: arcIcon,
    minLabel: 'Down',
    maxLabel: 'Up'
  },
  {
    name: 'arch',
    type: 'arch',
    values: [
      '3.0',
      '4.0',
      '5.0',
      '8.0',
      '10.0',
      '-10.0',
      '-8.0',
      '-5.0',
      '-4.0',
      '-3.0'
    ],
    defaultValue: '5.0',
    icon: archIcon,
    minLabel: 'Down',
    maxLabel: 'Up'
  },
  {
    name: 'bridge',
    type: 'bridge',
    values: ['5.0', '4.0', '3.0', '2.5', '2.0'],
    defaultValue: '3.0',
    icon: bridgeIcon,
    minLabel: 'Small',
    maxLabel: 'Large'
  },
  {
    name: 'valley',
    type: 'valley',
    values: ['5.0', '4.0', '3.0', '2.5', '2.0'],
    defaultValue: '2.0',
    icon: valleyIcon,
    minLabel: 'Small',
    maxLabel: 'Large'
  },
  {
    name: 'pinch',
    type: 'double-bridge',
    values: ['5.0', '4.0', '3.0', '2.5', '2.0'],
    defaultValue: '2.0',
    icon: pinchIcon,
    minLabel: 'Small',
    maxLabel: 'Large'
  },
  {
    name: 'bulge',
    type: 'blimp',
    values: ['1.25', '1.5', '2.0', '2.5', '3.0'],
    defaultValue: '2.0',
    icon: bulgeIcon,
    minLabel: 'Small',
    maxLabel: 'Large'
  },
  {
    name: 'perspective',
    type: 'corner',
    values: [
      '2.0/25.0/50.0',
      '1.5/25.0/50.0',
      '1.25/25.0/50.0',
      '1.25/50.0/50.0',
      '1.5/50.0/50.0',
      '2.0/50.0/50.0',
      '2.0/75.0/50.0',
      '1.5/75.0/50.0',
      '1.25/75.0/50.0'
    ],
    defaultValue: '2.0/50.0/50.0',
    icon: perspectiveIcon,
    minLabel: 'Left',
    maxLabel: 'Right'
  },
  {
    name: 'pointed',
    type: 'corner',
    values: [
      '2.0/50.0/100.0',
      '1.5/50.0/100.0',
      '1.25/50.0/100.0',
      '1.25/50.0/0.0',
      '1.5/50.0/0.0',
      '2.0/50.0/0.0'
    ],
    defaultValue: '2.0/50.0/0.0',
    icon: pointedIcon,
    minLabel: 'Bottom',
    maxLabel: 'Top'
  },
  {
    name: 'downward',
    type: 'pennant',
    values: [
      '0.25/2.0',
      '0.5/2.0',
      '0.75/2.0',
      '1.25/3.0',
      '1.5/3.0',
      '2.0/3.0'
    ],
    defaultValue: '2.0/3.0',
    icon: downwardIcon,
    minLabel: 'Narrow',
    maxLabel: 'Wide'
  },
  {
    name: 'upward',
    type: 'pennant',
    values: [
      '0.25/3.0',
      '0.5/3.0',
      '0.75/3.0',
      '1.25/2.0',
      '1.5/2.0',
      '2.0/2.0'
    ],
    defaultValue: '2.0/2.0',
    icon: upwardIcon,
    minLabel: 'Narrow',
    maxLabel: 'Wide'
  },
  {
    name: 'cone',
    type: 'pennant',
    values: [
      '0.25/1.0',
      '0.5/1.0',
      '0.75/1.0',
      '1.25/1.0',
      '1.5/1.0',
      '2.0/1.0'
    ],
    defaultValue: '2.0/1.0',
    icon: coneIcon,
    minLabel: 'Narrow',
    maxLabel: 'Wide'
  }
];
